if ( module.hot ) {
  module.hot.accept();
}

// handles online booking
var OnlineBooking = {

    /**
     * Enabled booking vendor || false
     * @type string
     */
    vendor: $('body').data('booking-vendor'),
    
    init:function(){
        this.bindEvents();
    },

    /**
     * Add event listeners
     * @return {void}
     */
    bindEvents:function(){
        $('.gpw-booking').on('click', OnlineBooking.handleBookingClick);
        // Sets 3rd party booking vendor in the event we have more than one enabled
        $('.multi-vendor-alert .booking').on('click', OnlineBooking.setBookingVendor);
    },

    /**
     * Callback - Fires booking vendor modal or does nothing if booking vendor doesn't have a booking modal
     * @param  {object} e  event object
     * @return {void}
     */
    handleBookingClick:function(e){
        // If not a modal link - return
        if (this.getAttribute("href") != "#") return;

        e.preventDefault();
        // Trigger click on 3rd part booking btn
        if(OnlineBooking.vendor == 'localMed') {
            $('.localmed-tab')[0].click(); // localMed modal - btn fixed to side of browser chrome.
        } else if (OnlineBooking.vendor == 'healthEngine') {
            $('#health-engine-book img').trigger('click'); // healthEngine modal - The btn in hidden in the footer.
        } else if (OnlineBooking.vendor == 'myHealth1st') {
            $('.1stAvailableWidget').trigger('click'); // myHealth1st (1stAvlailable) modal - The btn in hidden in the footer.
        }
    },

    /**
     * Sets a booking vendor. In the event more than one vendor is selected, we show a modal prompting
     * the user to select ONE 3rd party vendor in dspModal.cfm
     */
    setBookingVendor:function(){

      $('.save-vendors-loader').css('opacity', 1);
      $.ajax({
          type: 'POST',
          url: '/index.cfm?event=admin.setBookingVendor',
          data: { vendor: this.dataset.vendor },
          success: function(resp) {  
            $('.save-vendors-loader').hide('opacity', 0);
            $('.multi-vendor-modal .oh-no').hide();
            $('.multi-vendor-alert').hide();
            $('.multi-vendor-modal .success-gif').show();
            $('.multi-vendor-modal .success').show();
            setTimeout(function(){ 
                $('.multi-vendor-modal').modal('hide');
            }, 1900);
          }
      });

    }
}

OnlineBooking.init();



// WEBPACK FOOTER //
// ./gpw-online-booking.js